export type ToastKind = "success" | "error" | "info";

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
  /** Optional correlation id shown in muted mono for support. */
  correlationId?: string;
}

let nextId = 1;

class Toasts {
  items = $state<Toast[]>([]);

  push(kind: ToastKind, message: string, correlationId?: string): number {
    const id = nextId++;
    this.items = [...this.items, { id, kind, message, ...(correlationId ? { correlationId } : {}) }];
    // Errors linger; success/info auto-dismiss.
    if (kind !== "error") {
      setTimeout(() => this.dismiss(id), 5000);
    }
    return id;
  }

  success(message: string): number {
    return this.push("success", message);
  }

  error(message: string, correlationId?: string): number {
    return this.push("error", message, correlationId);
  }

  info(message: string): number {
    return this.push("info", message);
  }

  dismiss(id: number): void {
    this.items = this.items.filter((toast) => toast.id !== id);
  }
}

export const toasts = new Toasts();
